<template>
	<div class="wrap">
		<Dfadd ref="addDf" 
			:type="type" 
			@dataList="dataList"
			:flag="getdata.flag" 
			:id="getdata.user_id"></Dfadd>
		<DelData ref="delDatas"></DelData>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务管理</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="switchBar">
						<span
						v-if="$store.state.user.userinfo.flag!=3"
						:class="{selectSwitch:getdata.funds_class == 1}" 
						@click="changeType(1)">经费下拨</span>
						<span :class="{selectSwitch:getdata.funds_class == 2}" 
						@click="changeType(2)">经费支出</span>
					</div>
					<div class="selectbar">
						<div>
							<el-select
							 	style="margin-right: 10px;width: 120px !important" 
								clearable
								size="small"
								v-model="getdata.year" placeholder="请选择年份"
								@change="getdata.page = 1;totalPage = 0;dataList();">
								<el-option
									:key="index"
									v-for="(item,index) in $yearList()"
									:label="item"
									:value="item">
								</el-option>
							</el-select>
							<el-select
							size="small"
							 	style="width: 120px !important;" 
								clearable
								@change="getdata.page = 1;totalPage = 0;dataList();"
								v-model="getdata.month" placeholder="请选择月份">
								<el-option
									:key="index"
									v-for="(item,index) in $monthList()"
									:label="item+'月'"
									:value="item">
								</el-option>
							</el-select>
						</div>
						<div>
							<el-button type="primary" size="small" @click="delAll">一键删除</el-button>
							<el-button type="primary" size="small" @click="$refs.addDf.openWin();type='add'">新增</el-button>
							<el-button type="primary" size="small" @click="daochu">导出表格</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey="id"
							@selectList="selectList"
							:tableHeader="tableHeader"
							:loading="true" 
							:indexs="false"
							:selection="true">
						</myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import tree from '@/components/tree.vue'
	import { dwgl } from '@/axios'
	import Page from '@/components/page.vue'
	import { Message } from 'element-ui'
	import Dfadd from './components/jfzc.vue'
	import DelData from '@/components/delToast.vue'
	import myTables from '@/components/tables/tables.vue'
	let that;
	export default{
		data(){
			return{
				getdata:{
					flag: this.$store.state.user.userinfo.flag,
					user_id: this.$store.state.user.userinfo.id,
					year: "",
					month:"", 
					sign: 8,
					page:1,
					funds_class: 1
				},
				delList:[],
				type:'add',
				dialogVisible:false,//新增弹窗
				tableData:[],
				totalPage:0,
				tableHeader: []
			}
		},
		components:{tree,Page,Dfadd,DelData,myTables},
		created() {
			that = this;
			if(this.$store.state.user.userinfo.flag==3){
				this.getdata.funds_class = 2;
			}else{
				this.getdata.pid = this.$store.state.user.userinfo.pid;
			}
		},
		methods:{
			changeType(type){
				that.getdata.funds_class = type;
				that.delList = [];
				that.tableData = []
				that.tableHeader = [ 
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
					{
						prop: 'oper', label: '操作', fixed: 'right', width: '114',align:'center',
						oper: [
							{name: '编辑', style: {color:'#bb0000'}, clickFun: this.edit,show:true,limit:''},
							{name: '删除', style: {color:'#bb0000'}, clickFun: this.del,show:true,limit:''},
						]
				}]
				let tableHeader1 = [
					   // 表头
					{prop: 'allocate_class',label: '拨款名称'},
					{prop: 'p_name', label: '拨款单位'},
					{prop: 'u_name', label: '收款单位'},
					{prop: 'allocate_time', label: '时间',width:"105"},
					{prop: 'agent', label: '经办人',width:"100"},
					{prop: 'allocate_money', label: '金额',width:"90",formatData:function(val){
						return val+'￥'
					}}
				]
				let tableHeader2 = [
					   // 表头
					{prop: 'u_name',label: '组织名称'},
					{prop: 'allocate_class', label: '支出名称'},
					{prop: 'allocate_time', label: '时间',width:"105"},
					{prop: 'agent', label: '经办人',width:"100"},
					{prop: 'allocate_money', label: '金额',width:"90",formatData:function(val){
						return val+'￥'
					}}
				]
				if(type == 1){
					that.tableHeader = tableHeader1.concat(that.tableHeader);
				}else{
					that.tableHeader = tableHeader2.concat(that.tableHeader);
				}
				that.dataList();
			},
			// 数据
			dataList(){
				that.tableData = [];
				dwgl.funds(that.getdata).then(res => {
					that.tableData = res.data.pagedata;
					that.totalPage = res.data.count;
				})
			},
			// 分页查询
			changedata(current){
				that.getdata.page = current;
				that.dataList();
			},
			// 树形结构筛选
			treeSelect(data){
				that.getdata.user_id = data.id;
				that.getdata.flag = data.flag;
				that.getdata.page = 1;
				that.dataList();
			},
			// 编辑
			edit(data){
				that.$refs.addDf.openWin();
				that.type='edit';
				that.$refs.addDf.organMember();
				that.$refs.addDf.bindData(data)
			},
			// 一键删除
			selectList(value){
				that.delList = value;
			},
			delAll(){
				if(that.delList.length == 0){
					Message.warning('请先选择要删除得数据')
				}else{
					that.delData();
				}
			},
			//	删除操作
			delData(){
				that.$refs.delDatas.showToast(res => {
					if(res){
						dwgl.delFunds({
							id:that.delList,
						}).then(res => {
							if(res.code == 200){
								Message({
									type: 'success',
									message: '删除成功!'
								})
							}else{
								Message({
									type: 'error',
									message: res.msg
								})
							}
							that.getdata.page = 1;
							that.dataList();
						})
					}
				})
			},
			// 删除
			del(data){
				that.delList = [];
				that.delList = [data.id];
				that.delData();
			},
			// 导出表格
			daochu(){
				if(that.tableData.length != 0){
					if(that.getdata.funds_class == 1){
						// 下拨
						that.getdata.sign = 7
						dwgl.exportPartyOrgan(that.getdata);
					}else{
						that.getdata.sign = 8
						dwgl.exportPartyOrgan(that.getdata);
					}
				}else{
					Message({
						type:"warning",
						message:"暂无可导出的数据"
					})
				}
			}
		},
		mounted() {
			that.dataList();
			that.changeType(that.getdata.funds_class)
		}
	}
</script>

<style lang="scss">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 138px;
		    margin: 10px 16px 10px 14px;
		}
		.switchBar{
			width: 100%;
			height: 40px;
			line-height: 40px;
			margin-bottom: 20px;
			border-bottom: 1px solid #DDDDDD;
			span{
				cursor: pointer;
				display: inline-block;
				line-height: 40px;
				font-size: 16px;
				margin-right: 20px;
				padding: 0 20px;
				font-weight: bold;
			}
			span:hover{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
			.selectSwitch{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
		}
	}
</style>

